export const MY_NETWORK_FILTERS_KEYS = {
  name: 'name',
  segmentIds: 'segmentIds',
  retailMediumPrices: 'retailMediumPrices',
  wholesaleMediumPrices: 'wholesaleMediumPrices',
  status: 'status',
} as const;

export const MY_NETWORK_LIST_FILTERS_KEYS: string[] = [
  MY_NETWORK_FILTERS_KEYS.name,
  MY_NETWORK_FILTERS_KEYS.segmentIds,
  MY_NETWORK_FILTERS_KEYS.retailMediumPrices,
  MY_NETWORK_FILTERS_KEYS.wholesaleMediumPrices,
];

export const MY_NETWORK_EXPLORE_FILTERS_KEYS: string[] = [
  ...MY_NETWORK_LIST_FILTERS_KEYS,
  MY_NETWORK_FILTERS_KEYS.status,
];
